/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-1 8a4 4 0 0 1 8 0v2h-1v3H9v-3H8zm2 0h1v3h2v-3h1a2 2 0 1 0-4 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBoy as Boy };
